export default __webpack_public_path__ + "static/media/WIBS_1.776ed21e.png";